import { render, staticRenderFns } from "./myOrderList.vue?vue&type=template&id=15c44560"
import script from "./myOrderList.vue?vue&type=script&lang=js"
export * from "./myOrderList.vue?vue&type=script&lang=js"
import style0 from "./myOrderList.vue?vue&type=style&index=0&id=15c44560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports